export default __webpack_public_path__ + "static/media/Khurshed Thanawalla.8fb63a55.jpg";